module.exports = __webpack_public_path__ + "img/dongji_ps_31.fe79bd79.jpg";